import { render } from "./TheProducts.vue?vue&type=template&id=1c46bf0b&scoped=true"
import script from "./TheProducts.vue?vue&type=script&lang=js"
export * from "./TheProducts.vue?vue&type=script&lang=js"

import "./TheProducts.vue?vue&type=style&index=0&id=1c46bf0b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c46bf0b"]])

export default __exports__